/* eslint-disable camelcase */
import React from 'react';
import ColumnLayout from '@components/shared/layout/ColumnLayout';
import ShowAt from '@components/shared/conditional/ShowAt';
import PreviewCarousel from '@components/shared/PreviewCarousel';

import HandWaving from '@components/shared/HandWaving/HandWaving';
import Slide from '@components/shared/Slide/Slide';
import styleQuiz from '@constants/styleQuiz';

import { useTheme } from '@components/theme';
import classNames from 'classnames';
import useGetStartedCtaLink from '@hooks/useGetStartedCtaLink/useGetStartedCtaLink';
import styles from './FindYourStyle.module.scss';

const FindYourStyle = () => {
  const renderNextArrow = (next: () => void) => (
    <button
      title="Next"
      className={ `${styles.Chevron}` }
      onClick={ next }
      type="button"
    >
      <span className="havenly-icon caret" />
    </button>
  );
  const theme = useTheme();
  const link = useGetStartedCtaLink();

  return (
    <ColumnLayout className={ styles.Container } element="section" widths={ [40, 60] }>
      <div className={ styles.CalloutWrap }>

        <HandWaving className={ styles.Hand } />

        <div className={ styles.Title }>
          Need a hand?
        </div>

        <div className={ styles.SubText }>
          Let us do what we do best - get to know you and your unique style.
        </div>

        <a
          className={ classNames(theme.styles.Button, theme.styles.Conflicting) }
          href={link}
        >
          Get Started
        </a>
      </div>

      <ShowAt breakpoint="large-tablet">
        <div className={ styles.CarouselWrapper }>
          <PreviewCarousel
            className={styles.Carousel}
            renderNextArrow={renderNextArrow}
          >
            {styleQuiz.map((slide) => {
              return (
                <Slide key={ slide.id } slide={ slide } />
              );
            })}
          </PreviewCarousel>
        </div>
      </ShowAt>
    </ColumnLayout>
  );
};

export default FindYourStyle;
